
/*----------------------
    PRODUCT INFO
---------------------- */
ProductInfo = {
    init: function () {
        if (!$(".section-product-info").length) return;

        $(".product-info__tab").off("click.productInfo").on("click.productInfo", function () {
            var $tab = $(this);
            var index = $tab.data("tab-index");

            $(".product-info__tab").removeClass("is-active").attr("aria-selected", "false");
            $tab.addClass("is-active").attr("aria-selected", "true");

            $(".product-info__panel").removeClass("is-active").attr("hidden", true);
            $('.product-info__panel[data-panel-index="' + index + '"]').addClass("is-active").removeAttr("hidden");

            ProductInfo.updateTabIndicator($tab);
        });

        $(".product-info__accordion__title").off("click.productInfo").on("click.productInfo", function () {
            var $item = $(this).closest(".product-info__accordion__item");
            $item.toggleClass("is-open");
        });

        if ($(window).width() < 991) {
            $(".product-info__accordion__item").removeClass("is-open");
        }

        $(window).off("resize.productInfo").on("resize.productInfo", function () {
            if ($(window).width() < 991) {
                $(".product-info__accordion__item").removeClass("is-open");
            } else {
                $(".product-info__accordion__item").addClass("is-open");
                ProductInfo.updateTabIndicator($(".product-info__tab.is-active").first(), false);
            }
        });

        ProductInfo.updateTabIndicator($(".product-info__tab.is-active").first(), false);

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(function () {
                ProductInfo.updateTabIndicator($(".product-info__tab.is-active").first(), false);
            });
        }
    },

    updateTabIndicator: function ($tab, animate) {
        var $tabs = $(".product-info__tabs");
        var $indicator = $tabs.find(".product-info__tab-indicator");
        if (!$tabs.length || !$indicator.length || !$tab || !$tab.length) return;

        if (animate === false) {
            $tabs.removeClass("is-ready");
        }

        var tabEl = $tab[0];
        $indicator.css({
            width: tabEl.offsetWidth + "px",
            transform: "translateX(" + tabEl.offsetLeft + "px)"
        });

        requestAnimationFrame(function () {
            $tabs.addClass("is-ready");
        });
    },
};

$(document).ready(function () {
    ProductInfo.init();
});

$(document).on("shopify:section:load", function () {
    ProductInfo.init();
});
